const OrgAdmin = 'OrgAdmin';
const OrgUser = 'OrgUser';
const Trainer = 'Trainer';
const Official = 'Official';
const Statistiker = 'Statistiker';
const Approver = 'Approver';
const Any = 'Any';
const RecordAdmin = 'RecordAdmin';
const ManualBestlistAdmin = 'ManualBestlistAdmin';

export default {
	OrgAdmin,
	OrgUser,
	Trainer,
	Official,
	Statistiker,
	Approver,
	Any,
	RecordAdmin,
	ManualBestlistAdmin,
};
